import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchPharmacyOrders } from '../../../Redux/actions/orderActions';
import { Flex, Spin } from 'antd';
import MedicineOrdHistoryCard from './medicineOrdHistoryCard';

function Index({ activeTab }) {
    const { pharmacyOrders, isLoading } = useSelector((state) => state.orders);
    const dispatch = useDispatch();
    const loggedUserObj = localStorage.getItem("patientData");
    const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

    useEffect(() => {
        dispatch(fetchPharmacyOrders({ patientId: loggedUser?.patientId }));
    }, []);

    return (
        <div>
            {isLoading ? (
                <div className="flex items-center justify-center mt-[10%]">
                    <Flex align="center" gap="middle">
                        <Spin size="large" tip="Loading" />
                    </Flex>
                </div>
            ) : pharmacyOrders?.length === 0 ? (
                <div className="flex flex-col items-center justify-center">
                    <p className="font-medium text-xl">No data found!!</p>
                </div>
            ) : (
                <div className="w-full grid grid-cols-2 gap-3">
                    {
                        pharmacyOrders.map((order, idx) => (
                            <MedicineOrdHistoryCard key={idx} order={order} />
                        ))
                    }

                </div>
            )}
        </div>
    )
}

export default Index